import { TeoPDF } from '@/utils/teo-pdf/TeoPDF';

import tpiGraph from './assets/tpi-bg.png?inline';
import { C, percentageToColor } from './utils';

const TEXT_PART_WIDTH = 320;
const TPI_GRAPH_WIDTH = 140;
const TPI_GRAPH_AR = 951 / 709;
const TPI_CIRCLE_RADIUS = 32.25;

export function renderTextPerformanceIndex(pdf: TeoPDF, value?: Maybe<number>) {
  const pageBounds = pdf.getPageBounds();
  const originPos = pdf.position;

  const tpiPos = {
    x: pageBounds.right - TPI_GRAPH_WIDTH - 16,
    y: originPos.y + 8,
  };
  const centerPos = {
    x: tpiPos.x + TPI_GRAPH_WIDTH / 2,
    y: tpiPos.y + TPI_GRAPH_WIDTH / TPI_GRAPH_AR / 2 + 14,
  };

  pdf

    .addImage(tpiGraph, tpiPos, { width: 140 })
    .addArc(centerPos, {
      radius: TPI_CIRCLE_RADIUS,
      lineWidth: 3,
      color: C.Divider,
      rotation: 38,
      lengthDeg: 253,
    })
    .addArc(centerPos, {
      radius: TPI_CIRCLE_RADIUS,
      lineWidth: 3,
      color: percentageToColor(value ?? 0),
      rotation: 38,
      lengthDeg: 253 * ((value ?? 0) / 100) + 0.0001,
    })
    .setStrokeColor('black')

    .addText(value ? value.toFixed(0) : '--', {
      size: 28,
      font: value ? 'Helvetica-Bold' : 'Helvetica',
      color: C.Text,
      pos: {
        x: tpiPos.x,
        y: centerPos.y - 14 + 4,
      },
      width: 140,
      align: 'center',
    })

    .addText('% TPI', {
      font: 'Helvetica-Bold',
      size: 13,
      color: C.Text,
      pos: {
        x: tpiPos.x,
        y: tpiPos.y + TPI_GRAPH_WIDTH / TPI_GRAPH_AR,
      },
      width: 140,
      align: 'center',
    })

    .moveTextTo(originPos)
    //
    // .moveTo(originPos)
    .addSection('Text-Performance-Index (TPI)', (pdf) =>
      pdf
        .moveTo({ x: 0, y: 0 })
        .setFontSize(12)
        .addText(
          'Der Text Performance-Index (TPI) fasst die Einzelbewertungen eines Textes in einem Performance-Wert zusammen. Die Bewertung erfolgt auf einer Skala von 0 bis 100%. Der Benchmark (100%) basiert auf der oben aufgeführten Analyse-Konfiguration. Je höher der erreichte Wert, desto besser die prognostizierte Wirkung des Textes. Bei 100% erzielt der Text die optimale Wirkprognose.',
          { align: 'justify', width: TEXT_PART_WIDTH },
        ),
    );
}
